define('ordersDetailSupplierEditInvoiceView',[
  'module',
  'marionette',
  'underscore',
  'settings',
  'ordersController',
  'ordersDetailSupplierEditInvoicePackingListView',
  'ordersDetailSupplierEditInvoiceProductionSheetView',
  'template!ordersDetailSupplierEditInvoiceView'
], function (
  module,
  Marionette,
  _,
  Settings,
  Controller,
  PackingListView,
  ProductionSheetView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'delivery-view',

    ui: {
      packingList: '.packing-list a',
      packingListPreview: '.packing-list .preview',
      packingListCanvas: '.packing-list .preview .canvas',
      productionSheet: '.production-sheet a',
      productionSheetPreview: '.production-sheet .preview',
      deliverToCompany: '.deliver-to-company',
      deliveryAddressValue: '.delivery .value'
    },

    events: {
      'click @ui.packingList': 'onPackingList',
      'click @ui.packingListPreview': 'onPackingList',
      'click @ui.productionSheet': 'onProductionSheet',
      'click @ui.productionSheetPreview': 'onProductionSheet',
      'click @ui.deliverToCompany': 'onDeliverToCompany'
    },

    onRender: function() {
      this.renderPackingList();
      this.renderProductionSheet();
    },

    serializeData: function() {
      var data = {};

      data.deliveryAddress = Controller.createAddress(this.model.get('delivery'), '<br>');

      if(data.deliveryAddress.trim() === '')
        data.deliveryAddress = '-';

      data.email = '-';
      if(this.model.get('emailAddress'))
        data.email = this.model.get('emailAddress');

      data.advancedMode = !!Settings.configValue('advancedMode');
      data.companyName = '';
      var cAccountConfig = Settings.get('cAccountConfig');
      if (cAccountConfig) {
        var accountData = cAccountConfig.get('accountData');
        if (accountData && accountData.companyName)
          data.companyName = accountData.companyName;
      }

      data.packingList = '-';
      if (this.model.get('packingList') && this.model.get('packingList').filename)
        data.packingList = this.model.get('packingList').filename;

      data.showPackingList = false;
      if (this.model.get('packingList') && this.model.get('packingList').content)
        data.showPackingList = true;

      data.productionSheet = '-';
      if (this.model.get('productionSheet') && this.model.get('productionSheet').filename)
        data.productionSheet = this.model.get('productionSheet').filename;

      data.showProductionSheet = false;
      if (this.model.get('productionSheet') && this.model.get('productionSheet').content)
        data.showProductionSheet = true;

      return data;
    },

    renderPackingList: function () {
      if (this.model.get('packingList') && this.model.get('packingList').content) {
        // Loaded via <script> tag, create shortcut to access PDF.js exports.
        var pdfjsLib = window['pdfjs-dist/build/pdf'];

        // The workerSrc property shall be specified.
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.228/pdf.worker.min.js';

        // Asynchronous download of PDF
        var dataURI = 'data:application/pdf;base64, ' + this.model.get('packingList').content;
        var loadingTask = pdfjsLib.getDocument(dataURI);
        loadingTask.promise.then(_.bind(function (pdf) {
          // Fetch the first page
          var pageNumber = 1;
          pdf.getPage(pageNumber).then(_.bind(function (page) {
            var scale = 1;

            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = this.ui.packingListCanvas[0];
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              //console.log('Page rendered');
            });

          }, this));
        }, this), _.bind(function (reason) {
          console.error(reason);
        }, this));
      }
    },

    onPackingList: function () {
      PackingListView.prototype.open({
        model: this.model
      });
    },

    renderProductionSheet: function () {
      if (!this.model.get('productionSheet') || !this.model.get('productionSheet').content) {
        return;
      }

      var pdfjsLib = window['pdfjs-dist/build/pdf'];
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.228/pdf.worker.min.js';

      var dataURI = 'data:application/pdf;base64, ' + this.model.get('productionSheet').content;
      var loadingTask = pdfjsLib.getDocument(dataURI);

      loadingTask.promise.then(_.bind(function (pdf) {
        var previewEl = this.ui.productionSheetPreview[0];
        if (!previewEl) return;
        // Clear any previous render (e.g. when the view re-renders)
        previewEl.innerHTML = '';

        var numPages = pdf.numPages;
        var renderPage = _.bind(function (pageNumber) {
          if (pageNumber > numPages) return;

          pdf.getPage(pageNumber).then(_.bind(function (page) {
            var scale = 1;
            var viewport = page.getViewport({ scale: scale });

            var canvas = document.createElement('canvas');
            canvas.className = 'canvas page-' + pageNumber;
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            previewEl.appendChild(canvas);

            var renderContext = {
              canvasContext: canvas.getContext('2d'),
              viewport: viewport
            };
            page.render(renderContext).promise.then(_.bind(function () {
              renderPage(pageNumber + 1);
            }, this));
          }, this));
        }, this);

        renderPage(1);
      }, this), _.bind(function (reason) {
        console.error(reason);
      }, this));
    },

    onProductionSheet: function () {
      ProductionSheetView.prototype.open({
        model: this.model
      });
    },

    onDeliverToCompany: function () {
      var cAccountConfig = Settings.get('cAccountConfig');
      if (!cAccountConfig) return;
      var accountData = cAccountConfig.get('accountData');
      if (!accountData) return;

      var deliveryAddress = {
        name: accountData.companyName || '',
        addressL1: accountData.street ? accountData.street.split(' ')[0] : '',
        houseNumber: accountData.street ? accountData.street.split(' ')[1] : '',
        zip: accountData.zip || '',
        city: accountData.city || '',
        countryCode: accountData.country || ''
      };

      this.model.set('delivery', deliveryAddress);
      var address = Controller.createAddress(deliveryAddress, '<br>');
      this.ui.deliveryAddressValue.html(address || '-');
    }
  });
});
